import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { uploadAttendees } from "../../../../api/Event";
import { toast } from "react-toastify";
import { useRef, useState } from "react";

const AttendeeItem = ({ email, firstName, lastName, index }) => {
  return (
    <div className="attendee__item" data-index={index + 1}>
      <div className="attendee__name" title={`${firstName} ${lastName}`}>
        {firstName} {lastName}
      </div>
      <div className="attendee__email" title={email}>
        {email}
      </div>
    </div>
  );
};

const UploadAttendees = ({ refreshData, attendees = [], eventId }) => {
  const [isUploading, setIsUploading] = useState(false);
  const toastRef = useRef();
  const submitUpload = async () => {
    if (attendees.length === 0) return;
    if (!eventId) {
      toast.error("Event ID not found!");

      return;
    };

    toastRef.current = toast.loading("Uploading Attendees");

    setIsUploading(true);

    await uploadAttendees(attendees, eventId);

    toast.dismiss(toastRef.current);

    toastRef.current = toast.loading("Refreshing event data");

    await refreshData();

    
    toast.dismiss(toastRef.current);
    toast.success("Successfully uploaded attendees!");
  };
  return (
    <div className="upload__attendees">
      <div className="attendees__list">
        {attendees.map((item, index) => (
          <AttendeeItem
            key={item.email}
            email={item.email}
            firstName={item.first_name}
            lastName={item.last_name}
            index={index}
          />
        ))}
      </div>

      {!isUploading && (
        <div className="upload__btn">
          <button onClick={submitUpload}>Upload <FontAwesomeIcon icon={faUpload} /> </button>
        </div>
      )}
    </div>
  )
};

export default UploadAttendees;